<div class="mech-diag-content">
	<app-dvs-chart [error]="errormessage" [options]="residualoptions"></app-dvs-chart>
	<app-dvs-chart [error]="errormessage" [options]="amresoptions"></app-dvs-chart>
	<app-dvs-chart [error]="errormessage" [options]="amoptions"></app-dvs-chart>
	<app-dvs-chart [error]="errormessage" [options]="fmoptions"></app-dvs-chart>
	<app-dvs-chart [error]="errormessage" [options]="energyoptions"></app-dvs-chart>
</div>